module.exports = __webpack_public_path__ + "img/people-24px.a1a1234d.svg";